import type { FC, SVGAttributes } from 'react';

const Box: FC<SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M1.2522 4.43262L6.52661 7.28418V13.3486C6.40553 13.3133 6.28724 13.2684 6.17603 13.208V13.207L1.7229 10.8145L1.72192 10.8135C1.46166 10.6721 1.2414 10.4669 1.08716 10.2158C0.932835 9.9646 0.850252 9.67707 0.849854 9.38281V4.59082C0.850001 4.47123 0.863288 4.35267 0.889893 4.2373L1.2522 4.43262ZM13.1624 4.23633C13.1892 4.35211 13.2042 4.47075 13.2043 4.59082V9.38281C13.2039 9.67706 13.1214 9.9646 12.967 10.2158C12.8128 10.4668 12.5934 10.6721 12.3333 10.8135L12.3313 10.8145L7.8772 13.209L7.87622 13.208C7.76514 13.2682 7.64727 13.3132 7.52661 13.3486V7.28516L12.801 4.43262L13.1624 4.23633ZM7.02759 0.549805C7.32406 0.549849 7.61636 0.623898 7.87622 0.764648L12.3313 3.15918L12.3333 3.16016C12.4457 3.22124 12.5486 3.29641 12.6438 3.37988L12.3254 3.55371L7.02661 6.41797L1.72876 3.55371L1.40942 3.38086C1.5052 3.2969 1.60893 3.22154 1.72192 3.16016L1.7229 3.15918L6.17798 0.763672C6.4379 0.622902 6.73104 0.549805 7.02759 0.549805Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Box;
